export default __webpack_public_path__ + "static/media/pricing3.a7024b08.jpg";